import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import {
  IExtendedLink, ILinkMedia, ITag, PositionEnum, SdBannerComponent, SdHtmlComponent,
  SdLinkComponent, SdTagComponent, ThemesEnum
} from '@seb/web-design-system/core';
import { ITodoCard } from './todo-card.interface';
import { ITodoCardStatus } from '@seb/web-design-system/todo-card';

@Component({
  selector: 'sd-todo-card',
  templateUrl: './todo-card.component.html',
  styleUrls: ['./todo-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdLinkComponent,
    SdBannerComponent,
    SdTagComponent,
    SdHtmlComponent
  ]
})
export class SdTodoCardComponent implements OnInit {
  @Input()
  todoCardData: ITodoCard;

  @Output()
  linkClicked = new EventEmitter<any>();

  @Input()
  class: string;

  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.todoCardData?.status ? 'is-' + this.todoCardData?.status : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  tag: ITag;

  ngOnInit() {
    const status = this.todoCardData?.status;
    this.tag = {
      text: this.todoCardData?.tagLabel,
      theme: status === ITodoCardStatus.success
        ? ThemesEnum.activeSuccess
        : ThemesEnum.pending,
      icon: status === ITodoCardStatus.success
        ? 'icon-check-circle-2'
        : 'icon-dash-circle',
      iconPos: PositionEnum.left
    };
  }

  onClickLink(event: IExtendedLink | ILinkMedia): void {
    this.linkClicked.emit({ link: event });
  }
}
